import React from "react";
import { useState, useEffect } from "react";
import TemplateComponent from "../../containers/template_page/template_component/template_component";
import Slider from "react-slick";
import "./c100_profile_card.scss"
import EmailIcon from '@material-ui/icons/Email';
import ShareIcon from '@material-ui/icons/Share';
import PermIdentity from '@material-ui/icons/PermIdentity';
import ChevronRight from "@material-ui/icons/ChevronRight";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import Menu from "@material-ui/icons/Menu";
import MenuOpen from "@material-ui/icons/MenuOpen";
import axios from "axios";
import { API_CONFIG } from "../../config/api_config";
import Select from 'react-select';
import { fixProfessorName, initCap } from "../../utils/utils";

var classNames = require('classnames');

class C100ProfileCard extends TemplateComponent {

    constructor(props) {
        super(props);
        this.state = {
            activeTab: 'contatti',
            insegnamentiPerPage: 3,
            publicationsPerPage: 5,
            currentPageINS: 1,
            currentPagePUB: 1,
            mobileMenu: false,
            searchInput: "",
            orderBy: "",
            publicationsFilter: "",
            accessType: "",
        };

        this.requireInternationalization = true;
    };


    componentDidMount() {
        this.mounted = true;
        const elementsToHide = document.getElementsByClassName('top-title p-name extra-margin-top');

        if (elementsToHide.length > 0) {
            elementsToHide[0].parentElement.innerHTML = "";
        }
        if (this.props.data) {
            let tempData = this.props.data;
            const hasTeachings = this.props.data && this.props.data.teachings &&
                this.props.data.teachings.filter(t => t.hours > 0).length > 0;

            if (!hasTeachings) {
                tempData.teachings = [];
                this.setState({ data: tempData });

            }
        } else {
            const myUrl = new URL(window.location.toLocaleString());
            const professorId = myUrl.pathname.split('/')[2];
            axios.get(API_CONFIG.BASE_URL + '/professor/' + professorId + '/' + this.props.language)
                .then(response => {

                    const hasTeachings = response.data && response.data.teachings &&
                        response.data.teachings.filter(t => t.hours > 0).length > 0;

                    if (!hasTeachings) {
                        response.data.teachings = [];
                    }
                    this.setState({ data: response.data });
                })
                .catch(error => {
                    console.log(error);
                });
        }
    };

    internationalComponentRender(data, t) {
        const publicationsFilterOptions = [
            { value: 'all', label: t("C100 filter by publication type all") },
            /*{ value: 'chapter', label: t("C100 filter by publication type chapter") },
            { value: 'article', label: t("C100 filter by publication type article") },
            { value: 'online-portal', label: t("C100 filter by publication type online-portal") },
            { value: 'editorship', label: t("C100 filter by publication type book") },*/
        ];

        if (data.publications) {
            publicationsFilterOptions.push(...new Map(
                data.publications.map((publication) => {
                    return { value: publication.type, label: initCap(publication.type_label) };
                }).map(item => [item['value'], item])).values());
        }

        const orderByOptions = [
            //{ value: 'all', label: t("C100 sort pubblication by year none")},
            { value: 'asc', label: t("C100 sort pubblication by year asc") },
            { value: 'desc', label: t("C100 sort pubblication by year desc") },
        ];

        const accessTypeOptions = [
            { value: 'all', label: t("C100 filter by access type all") },
            /*{ value: 'open', label: t("C100 filter by access type open") },
            { value: 'partially_open', label: t("C100 filter by access type partially-open") },*/
        ];

        if (data.publications) {
            accessTypeOptions.push(...new Map(
                data.publications.map((publication) => {
                    return { value: publication.access, label: initCap(publication.access_label) };
                }).map(item => [item['value'], item])).values());
        }

        useEffect(() => {
            //document.title = t('Professor') + ": " + data.name + ' | LUISS Guido Carli';
        }, []);

        if (!data.publications) {
            data.publications = [];
        }

        if (!data.teachings) {
            data.teachings = [];
        }


        //insegnamenti pagination
        // Calculate the total number of pages for items
        const totalPagesINS = Math.ceil(data.teachings.length / this.state.insegnamentiPerPage);
        // Create an array of page numbers for rendering the pagination buttons
        const pageNumbersINS = [];
        for (let i = 1; i <= totalPagesINS; i++) {
            pageNumbersINS.push(i);
        }
        // Define a function to handle the forward button click
        const handleForwardINS = () => {
            // Get the current page number from the state
            const currentPageINS = this.state.currentPageINS;
            // Check if there is a next page available
            if (currentPageINS < totalPagesINS) {
                // Increment the page number by one
                const nextPage = currentPageINS + 1;
                // Set the current page state to the next page number
                this.setState({ currentPageINS: nextPage });
            }
        };
        // Define a function to handle the backward button click
        const handleBackwardINS = () => {
            // Get the current page number from the state
            const currentPageINS = this.state.currentPageINS;
            // Check if there is a previous page available
            if (currentPageINS > 1) {
                // Decrement the page number by one
                const prevPage = currentPageINS - 1;
                // Set the current page state to the previous page number
                this.setState({ currentPageINS: prevPage });
            }
        };
        // Calculate the index of the last item on the current page
        const indexOfLastItemINS = this.state.currentPageINS * this.state.insegnamentiPerPage;
        // Calculate the index of the first item on the current page
        const indexOfFirstItemINS = indexOfLastItemINS - this.state.insegnamentiPerPage;
        // Slice the items array to get only the items on the current page
        const currentItemsINS = data.teachings.slice(indexOfFirstItemINS, indexOfLastItemINS);

        //publicazioni pagination

        const { searchInput, orderBy, publicationsFilter, accessType } = this.state;

        let filteredPublications = data?.publications.filter((publication) => {

            // You can modify the conditions based on your search criteria
            return (
                (publication.title.toLowerCase().includes(searchInput.toLowerCase()) ||
                    publication.subtitle.toLowerCase().includes(searchInput.toLowerCase()) ||
                    publication.type.toLowerCase().includes(searchInput.toLowerCase()) ||
                    publication.year.toLowerCase().includes(searchInput.toLowerCase()))
                && (!publicationsFilter || publication.type.includes(publicationsFilter))
                && (!accessType || publication.access.includes(accessType))
            );

        });

        if (!orderBy) {
            this.setState({ orderBy: 'desc' });
        }

        if (orderBy) {
            filteredPublications = filteredPublications.sort((a, b) => {
                if (orderBy === 'asc') {
                    return a.year - b.year;
                } else {
                    return b.year - a.year;
                }
            });
        }

        // Calculate the index of the last item on the current page
        const indexOfLastItemPUB = this.state.currentPagePUB * this.state.publicationsPerPage;
        // Calculate the index of the first item on the current page
        const indexOfFirstItemPUB = indexOfLastItemPUB - this.state.publicationsPerPage;
        // Slice the items array to get only the items on the current page

        // Calculate the total number of pages for items
        const totalPagesPUB = Math.ceil(filteredPublications.length / this.state.publicationsPerPage)
        const currentItemsPUB = filteredPublications.slice(indexOfFirstItemPUB, indexOfLastItemPUB);
        // Create an array of page numbers for rendering the pagination buttons
        const pageNumbersPUB = [];
        for (let i = 1; i <= totalPagesPUB; i++) {
            pageNumbersPUB.push(i);
        }
        // Define a function to handle the forward button click
        const handleForwardPUB = () => {
            // Get the current page number from the state
            const currentPagePUB = this.state.currentPagePUB;
            // Check if there is a next page available
            if (currentPagePUB < totalPagesPUB) {
                // Increment the page number by one
                const nextPage = currentPagePUB + 1;
                // Set the current page state to the next page number
                this.setState({ currentPagePUB: nextPage });
            }
        };
        // Define a function to handle the backward button click
        const handleBackwardPUB = () => {
            // Get the current page number from the state
            const currentPagePUB = this.state.currentPagePUB;
            // Check if there is a previous page available
            if (currentPagePUB > 1) {
                // Decrement the page number by one
                const prevPage = currentPagePUB - 1;
                // Set the current page state to the previous page number
                this.setState({ currentPagePUB: prevPage });
            }
        };

        const BuildSelect = (options, placeholder, onChange, stateField) => {
            return (
                <Select options={options} placeholder={placeholder} styles={{
                    control: (baseStyles, state) => ({
                        ...baseStyles,
                        border: state.isFocused ? 0 : 0,
                        // This line disable the blue border
                        boxShadow: state.isFocused ? 0 : 0,
                        '&:hover': {
                            border: state.isFocused ? 0 : 0
                        },
                        width: '248px',
                        borderStyle: 'none',
                        height: '20px',
                        backgroundColor: 'transparent',
                    }),
                    placeholder: (baseStyles, state) => ({
                        ...baseStyles,
                        color: '#777777',
                        width: '248px',
                        marginTop: '-8px',
                    }),
                    container: (baseStyles, state) => ({
                        ...baseStyles,
                        border: 'none',
                        width: '248px',
                        borderStyle: 'none',
                        height: '20px',
                    }),
                    indicatorsContainer: (baseStyles, state) => ({
                        ...baseStyles,
                        border: 'none',
                        height: '20px',
                    }),
                    input: (baseStyles, state) => ({
                        ...baseStyles,
                        border: 'none',
                        color: '#777777',
                        height: '40px',
                        marginTop: '-9px',
                    }),
                    valueContainer: (baseStyles, state) => ({
                        ...baseStyles,
                        border: 'none',
                        height: '36px',
                        padding: '0px',
                    }),
                    menu: (baseStyles, state) => ({
                        ...baseStyles,
                        paddingTop: '6px',
                        paddingLeft: '4px',
                        paddingRight: '4px',
                        paddingBottom: '6px',
                        width: '280px'
                    }),
                    singleValue: (baseStyles, state) => ({
                        ...baseStyles,
                        marginTop: '-6px',
                    }),
                }}
                    onChange={(event) => onChange(event)} value={options.filter((option) => option.value === stateField)} />
                /*
                <select className="dropdown-filter" onChange={(event) => onChange(event)}>
                {options.map((option, index) => {

                    if(index === 0) {
                        if(stateField === option.value) {
                            return (
                                <option value={option.value} selected disabled hidden>{option.label}</option>
                            );
                        } else {
                            return (
                                <option value={option.value} disabled hidden>{option.label}</option>
                            );
                        }
                    }

                        if(stateField === option.value) {
                            return (
                                <option value={option.value} selected>{option.label}</option>
                            );
                        } 
                            
                        return (
                        <option value={option.value}>{option.label}</option>
                        );})}
                </select>*/
            )
        };

        const handleSearchInputChange = (event) => {
            this.setState({ searchInput: event.target.value, currentPagePUB: 1 });
        };

        const handleOrderByChange = (event) => {
            this.setState({ orderBy: event.value === 'all' ? '' : event.value });
        };

        const handlePublicationsFilterChange = (event) => {
            this.setState({ publicationsFilter: event.value === 'all' ? '' : event.value });
        };

        const handleAccessTypeChange = (event) => {
            this.setState({ accessType: event.value === 'all' ? '' : event.value });
        };

        return (
            <div className="profile-card-container">
                <div className="profile-card">
                    <div className={data.type ? classNames("profile-overview col-5 ", data.type + "-bg") : "profile-overview col-5 core-bg"}>
                        <div className="profile-title">
                            {data.type === 'core' || data.type === null ? "Core Faculty" : "Extended Faculty"}
                        </div>
                        <div className="profile-subtitle">
                            {data.department}
                        </div>
                        <div className="avatar-container">
                            <div className="avatar">
                                {data.photo.includes('placeholder') ? <img src='./professor_profile.png' /> : <img src={data.photo} />}
                            </div>
                        </div>
                        <div className="profile-name">
                            {fixProfessorName(data.name)}
                            <hr />
                        </div>
                        <div className="profile-details">
                            {data.job}
                        </div>
                        <div className="button">
                            <button className={data.type ? data.type : "core"} onClick={() => this.setState({ activeTab: 'contatti' })}>{t("C100 label contatti-cv")}</button>
                        </div>
                    </div>
                    <div className={classNames("mobile-menu")}>

                        {this.state.mobileMenu && <div className="menu-list">
                            {data.bio && <button onClick={() => this.setState({ activeTab: 'biografia' })}>{t("C100 title biography")}</button>}
                            {data.teachings && data.teachings.length > 0 && <button onClick={() => this.setState({ activeTab: 'insegnamenti' })}>{t("C100 title teaching")}</button>}
                            {data.type == "core" && data.publications && data.publications.length > 0 && <button onClick={() => this.setState({ activeTab: 'pubblicazioni' })}>{t("C100 title pubblication")}</button>}
                            {data.researchInterests && data.researchInterests.length > 0 && <button onClick={() => this.setState({ activeTab: 'ricerca' })}>{t("C100 title research interests")}</button>}
                        </div>}
                        <button className="hamburger-button" onClick={() => this.state.mobileMenu ? this.setState({ mobileMenu: false }) : this.setState({ mobileMenu: true })}>{this.state.mobileMenu ? <MenuOpen /> : <Menu />}</button>
                    </div>
                    <div className="content ">
                        <div className="d-flex flex-row justify-content-between">
                            {this.state.activeTab === 'contatti' ?
                                <div className="col-8">

                                    <div className={classNames("contact-title", data.type)}>
                                        {t("C100 title contacts-cv")}
                                    </div>
                                    {data.cv && (
                                        <div className="cv-box shadowBox">
                                            <div className="title">
                                                {data.name}
                                            </div>
                                            <button className={data.type ? data.type + "-bg" : "core-bg"}><a style={{ textDecoration: 'none', color: 'white' }} href={API_CONFIG.BASE_URL + data.cv} target="_blank">{t("C100 button download current-cv")}</a></button>
                                        </div>
                                    )}
                                    <div className="contact-box shadowBox">
                                        <div className="title">
                                            {t("C100 label contatti")}
                                        </div>
                                        <div className="share-info">
                                            <div className="email">
                                                <EmailIcon />{data.email}
                                            </div>  {/* todo: add socials
                                            <div className="social">
                                                <ShareIcon />
                                            </div>
                                            <div className="id">
                                                <PermIdentity />
                                            </div> */}
                                        </div>
                                    </div>
                                </div> :
                                this.state.activeTab === "biografia" ?
                                    <div className="col-8">
                                        <div className={classNames("contact-title", data.type)}>
                                            {t("C100 button biografia")}
                                        </div>
                                        <div className="biografia" dangerouslySetInnerHTML={{ __html: data.bio }} />
                                    </div>
                                    : this.state.activeTab === "insegnamenti" ?
                                        <div className="col-8">
                                            <div className={classNames("contact-title", data.type)}>
                                                {t("C100 button insegnamenti")}
                                            </div>

                                            <div className="insegnamenti-cards">
                                                {currentItemsINS.map((publication) => (
                                                    <div className="insegnamenti-card row shadowBox">
                                                        <div className="left">
                                                            <a className="name" href={publication.syllabus_url} >{publication.name}</a>
                                                            <div className="type">{t("C100 table title insegnamento")}</div>
                                                            <div>
                                                                <a className="course" href={publication.course_url} >{publication.course}</a>
                                                                <span>(<a className="department" href={publication.department_url}>{publication.department}</a>)</span>
                                                            </div>
                                                            {/* <div className={classNames("school ", data.type)} href="www.google.com" >{publication.dipcod}</div> */}
                                                        </div>
                                                        <div className="right">
                                                            <div className="badge rounded-pill">{publication.cfu} {t("C100 table title CFU")}</div>
                                                            <div className="hours">{publication.hours} {t("C100 table title hours")}</div>
                                                        </div>
                                                    </div>


                                                ))}
                                            </div>

                                            <div className="pagination">
                                                <button className={1 === this.state.currentPageINS ? "disabled" : ""} onClick={handleBackwardINS}><ChevronLeft /></button>
                                                {pageNumbersINS.map((number) => (
                                                    <button
                                                        key={number}
                                                        value={number}
                                                        onClick={() => this.setState({ currentPageINS: number })}
                                                        className={number === this.state.currentPageINS ? "active" : ""}
                                                    >
                                                        {number}
                                                    </button>
                                                ))}
                                                <button className={pageNumbersINS.length === this.state.currentPageINS ? "disabled" : ""} onClick={handleForwardINS}><ChevronRight /></button>
                                            </div>
                                        </div>
                                        : this.state.activeTab === "pubblicazioni" ?
                                            <div className="publicazioni-content">
                                                <div className="publications-upper">
                                                    <div className="publications-title-filters">
                                                        <div className={classNames("contact-title", data.type)}>
                                                            {t("C100 title pubblicazioni")}
                                                        </div>
                                                        <div className="pubblicazioni-filters">
                                                            <form>
                                                                <label>

                                                                    <input type="search" value={searchInput}
                                                                        onChange={handleSearchInputChange} placeholder={t("C100 search by pubblication")} /><svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" className="css-i6dzq1">
                                                                        <circle cx="11" cy="11" r="8"></circle>
                                                                        <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                                                                    </svg>
                                                                </label>
                                                                <label>
                                                                    {BuildSelect(orderByOptions, t("C100 sort pubblication by year"), handleOrderByChange, this.state.orderBy)}
                                                                </label>
                                                                <label>
                                                                    {BuildSelect(publicationsFilterOptions, t("C100 filter by publication type"), handlePublicationsFilterChange, this.state.publicationsFilter)}
                                                                </label>
                                                                <label>
                                                                    {BuildSelect(accessTypeOptions, t("C100 filter by access type"), handleAccessTypeChange, this.state.accessType)}
                                                                </label>

                                                            </form>

                                                        </div>
                                                    </div>

                                                </div>

                                            </div>
                                            : this.state.activeTab === "ricerca" ?
                                                <div className="col-8">
                                                    <div className={classNames("contact-title", data.type)}>
                                                        {t("C100 title research interests")}
                                                    </div>
                                                    {data.researchInterests.map((item) => (
                                                        <div className="interessi-box shadowBox">
                                                            {item.name}
                                                        </div>
                                                    ))}
                                                </div>
                                                : {}
                            }
                            <div className="menu col-4">
                                {data.bio && <button className={data.type ? data.type + "-bg" : "core-bg"} style={{ width: this.state.activeTab === 'biografia' ? '290px' : '234px' }} onClick={() => this.setState({ activeTab: 'biografia' })}>{t("C100 title biography")}</button>}
                                {data.teachings && data.teachings.length > 0 && <button className={data.type ? data.type + "-bg" : "core-bg"} style={{ width: this.state.activeTab === 'insegnamenti' ? '290px' : '234px' }} onClick={() => this.setState({ activeTab: 'insegnamenti' })}>{t("C100 title teaching")}</button>}
                                {data.type == "core" && data.publications && data.publications.length > 0 && <button className={data.type ? data.type + "-bg" : "core-bg"} style={{ width: this.state.activeTab === 'pubblicazioni' ? '290px' : '234px' }} onClick={() => this.setState({ activeTab: 'pubblicazioni' })}>{t("C100 title pubblicazioni")}</button>}
                                {data.researchInterests && data.researchInterests.length > 0 && <button className={data.type ? data.type + "-bg" : "core-bg"} style={{ width: this.state.activeTab === 'ricerca' ? '290x' : '234px' }} onClick={() => this.setState({ activeTab: 'ricerca' })}>{t("C100 title research interests")} </button>}
                            </div>
                        </div>
                        {this.state.activeTab === "pubblicazioni" && <div className="publications">
                            <div className="list">
                                {currentItemsPUB.map((publication) => (
                                    <div className="publication">
                                        <div className="left">
                                            <div className="publication-title"><a href={`${publication.handle}?mode=complete`} >{publication.title}</a></div>
                                            <div className="publication-author">{publication.subtitle}</div>
                                        </div>
                                        <div className="right publication-type">
                                            <div className="type">{initCap(publication.type_label)}</div>
                                            <div className="year">{publication.year}</div>
                                        </div>
                                    </div>



                                ))}
                            </div>
                            <div className="pagination">
                                <button className={this.state.currentPagePUB === 1 ? "disabled" : ""} onClick={handleBackwardPUB}><ChevronLeft /></button>
                                {pageNumbersPUB.filter(x => {
                                    if (this.state.currentPagePUB > 2 && x == 1) {
                                        return true
                                    }
                                    if (this.state.currentPagePUB < pageNumbersPUB.length - 1 && x == pageNumbersPUB.length) {
                                        return true
                                    }
                                    if (x >= this.state.currentPagePUB - 1 && x <= this.state.currentPagePUB + 1) {
                                        return true
                                    }
                                    return false
                                }).map((number) => {
                                    if (number == 1 && this.state.currentPagePUB > 3) {
                                        return (
                                            <>
                                                <button
                                                    key={number}
                                                    value={number}
                                                    onClick={() => this.setState({ currentPagePUB: number })}
                                                    className={number === this.state.currentPagePUB ? "active" : ""}
                                                >
                                                    {number}
                                                </button>
                                                <div style={{ fontSize: "26px" }}>
                                                    ...
                                                </div>
                                            </>)
                                    }
                                    if (number == pageNumbersPUB.length && this.state.currentPagePUB < pageNumbersPUB.length - 2) {
                                        return (
                                            <>
                                                <div style={{ fontSize: "26px" }}>
                                                    ...
                                                </div>
                                                <button
                                                    key={number}
                                                    value={number}
                                                    onClick={() => this.setState({ currentPagePUB: number })}
                                                    className={number === this.state.currentPagePUB ? "active" : ""}
                                                >
                                                    {number}
                                                </button>
                                            </>)
                                    }
                                    return (<button
                                        key={number}
                                        value={number}
                                        onClick={() => this.setState({ currentPagePUB: number })}
                                        className={number === this.state.currentPagePUB ? "active" : ""}
                                    >
                                        {number}
                                    </button>)
                                })}
                                <button className={pageNumbersPUB.length === this.state.currentPagePUB ? "disabled" : ""} onClick={handleForwardPUB}><ChevronRight /></button>
                            </div>
                        </div>}
                    </div>
                </div></div>)
    }
}

export default C100ProfileCard;